<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @stopFn="stopFn"
      />
      <div class="componentPage">
        <bindTable
          :tableData="tableData"
          v-bind="$attrs"
          :loading="loading"
          @stopUseFn="stopUseFn"
          @choozeTable="choozeTable"
          @historyFn="historyFn"
          @detailFn="detailFn"
          @dataHandleFn="dataHandleFn"
        />
        <Pagination
          class="pagination"
          :total="total"
          :page.sync="SearchForm.iDisplayStart"
          :limit.sync="SearchForm.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import bindTable from './bindTable.vue'
// import Config from '../components/ConfigDialog.vue';
import { baseList, updateBaseStatus } from '@/api/modules/base.js'
import { baseHistory } from '@/utils/winDetail'
import { sBaseNo, sBaseType, sBindedDevice, sCarrier } from '../config/search'
import { getDeviceTypeToSelection } from '@/utils/searchSelectFormat'

export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    bindTable
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },
  data () {
    return {
      formContent: [sBaseNo, sCarrier, sBindedDevice, sBaseType],
      SearchForm: {
        name: null,
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        type: '',
        mac: null,
        carrierName: null,
        status: '',
        configStatus: null
      },
      total: 0,
      optareBtn: [
        // {
        //     id: 1,
        //     icon: '',
        //     vHas: ['incubatorAddCarrier'],
        //     text: 'public.stop',
        //     method: 'stopFn'
        // }
        // {
        //     id: 2,
        //     icon: '',
        //     vHas: ['incubatorAddCarrier'],
        //     text: 'public.net_param',
        //     method: 'netFn'
        // }
      ],
      choozeTableData: [],

      title: '',

      // 详情
      isDetailShow: false,
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      netObj: {}
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }

    // 获取类型
    const item = this.formContent.find(item => item.paramsName === 'type')
    getDeviceTypeToSelection('base', item)
    console.log('item=', item)
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.loading = true
      baseList(this.SearchForm, 'bind')
        .then(res => {
          const { result, pageInfo } = res.result
          this.tableData = result

          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        type: null,
        mac: null,
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        carrierName: null,
        status: null,
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj =
        this.$store.state.SchemaTree[0].sceneCode === 'all_node'
          ? null
          : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      // const query = qs.stringify({ ids: idList.join(','), status: 2 });
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          updateBaseStatus(idList.join(','), 'unused').then(
            async ({ state }) => {
              await this.$resultHandle(state)

              this.getListFn()
            }
          )
        })
        .catch(() => {})
    },
    /** 单条停用 */
    stopUseFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          // const query = qs.stringify({ ids: row.id, status: 2 });
          updateBaseStatus(row.id, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 绑定历史 */
    historyFn (row) {
      bus.$emit('bindHistoryParam', row.id)
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('baseParam', row.id, row.plinthCode, this.getListFn)
    },
    dataHandleFn (row) {
      baseHistory(row.plinthCode)
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  width: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
